import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import SignupOptionsMobile from "./SignupOptionsMobile";
import SignupTitleMobile from "./SignupTitleMobile";
import SingupBoxInfoMobile from "./SignupBoxInfoMobile";

const Container = styled.div`
  margin: 0 auto;
  @media (max-width: ${({ theme }) => theme.breakpoints.mobileL}) {
    max-width: 365px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileM}) {
    max-width: 315px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileS}) {
    max-width: 265px;
  }
`;

const Wrapper = styled.div`
  background: ${({ theme }) => theme.backgroundColor};
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.4);
  padding: 0 20px 0 20px;
  border-radius: 10px;
  display: grid;
  row-gap: 30px;
`;

const SignupBoxMobile = () => {
  const { t } = useTranslation();
  return (
    <Container id="signup-box">
      <Wrapper>
        <SignupTitleMobile
          title={t("signup-box-title")}
          description={t("signup-box-description")}
        />
        <SignupOptionsMobile />
        <SingupBoxInfoMobile>{t("signup-box-info")}</SingupBoxInfoMobile>
      </Wrapper>
    </Container>
  );
};

export default SignupBoxMobile;
